import { Component, ViewChild, OnInit, Injectable, Input } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MdPaginator } from "@angular/material";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";
import { IncassiService } from "../../../../../services/incassi.service";
import { AuthService } from "../../../../../services/auth.service";
import { IncassoListItemModel } from "../../../../../models/incassi/incasso-list-item.model";
import { ComponentInterface } from "../../models/component.interface";
import { Router } from "@angular/router";
import { DashboardService } from "../../../../../services/dashboard.service";

@Component({
  selector: "app-incassi-rendicontare",
  templateUrl: "./incassi-rendicontare.component.html",
  styleUrls: ["./incassi-rendicontare.component.css"],
})
export class IncassiRendicontareComponent
  implements OnInit, ComponentInterface {
  @Input() config;

  isLoading: boolean = false;

  countIncassiDaRendicontare: number = 0;
  title: string;
  subtitle: string;

  constructor(
    private _incassiService: IncassiService,
    private _dashboardService: DashboardService,
    public _authService: AuthService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
      });
    this._incassiService
      .getListDaRendicontare()
      .finally(() => (this.isLoading = false))
      .subscribe((i) => {
        if (i) {
          this.countIncassiDaRendicontare = i.length;
        } else {
          this.countIncassiDaRendicontare = 0;
        }
      });
  }

  goTo() {
    // this._router.navigate(["/nuovobrogliaccio"]);
    window.open("/nuovobrogliaccio", "_blank");
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/incassi-rendicontare/incassi-rendicontare.component.ts